import React, { useState, useEffect, useContext } from "react";
import { Card, makeStyles, useMediaQuery } from "@material-ui/core";
import E_card_Header from "./_card_header";
import E_Card_Search from "./_card_search";
import E_Card_Content from "./_card_content";
import E_Prepaid_Alerts from "./_prepaid_alerts";
import { useDispatch, useSelector } from "react-redux";
import E_PaginatationComponent from "./e_alerts_notification_pagination";
import { config } from "../../../enviroment";
import { e_meterAlertsDataCount } from "../model/e_meter_alerts_action";
import moment from "moment";
import { AutoOpenContext } from "../e_alerts_notification";

const useStyle = makeStyles((theme) => ({
  hrStyle: { margin: "0 0 5px 0px" },
  insideCard: {
    height: "29rem"
  },
  smallInsideCard: {
    height: "29.5rem"
  },
}));
export default function E_Alerts_Card({ title, data, origin, noContent, noContentContentReady, labelReady,setAnnLoad ,setMeterLoad,meterLoad,annLoad}) {
  const PREPAID_VALUE = "PREPAID";
  const ANNOUNCEMENT_VALUE= "ANNOUNCEMENT"
  const { autoOpenData, setAutoOpenData }=useContext(AutoOpenContext);

  let [dropdownData, setDropdownData] =  useState([]);
  let [searchUndoData, setSearchUndoData] = useState([]);
  let [value, setValue] = useState(0);
  const [searchCount, setSearchCount] = useState(0);
  useEffect(()=>{
    setDropdownData(data);
  },[data]);
  let classes = useStyle();
  let dispatch = useDispatch();
  const minTablet = useMediaQuery("(min-height:1010px)");
  let isPrepaidSa = useSelector(
    (store) => store?.meterDetails?.getSaInfo?.isPrepaidSa
  );
  let dateFormat = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.E_DATE_MONTH_YEAR_FORMAT
  );
  let count = useSelector((state) => state?.e_meterAlertsDataCount?.data);
  
  let dateTimeFormat = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.DATE_TIME_FORMAT
  );
  useEffect(() => {
    if (data && origin && count) {
      if (origin !== PREPAID_VALUE) {
        let unreadData = data.filter((i) => i.IsRead === 0);
        count[origin] = unreadData;
        dispatch(e_meterAlertsDataCount(count));
      } else {
        data &&
          data.map((item) => {
            let unreadData = item.alertsData.filter((i) => i.IsRead === 0);
            count[item.origin] = unreadData;
            dispatch(e_meterAlertsDataCount(count));
          });
      }
    }
  }, [data, origin, count]);

  let postpaidRowCount = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.E_ALERTS_NOTIFICATION_POSTPAID_PAGINATION
  );
  const browserName = useSelector((store) => store?.browserDetect?.browserName);
  const [rowsPerPage, setRowsPerPage] = useState(postpaidRowCount);
  const [page, setPage] = useState(1);
  const [totalPagesCount, setTotalPagesCount] = useState(
    Math.ceil(dropdownData?.length / rowsPerPage)
  );
  if (Math.ceil(dropdownData?.length / rowsPerPage) !== totalPagesCount) {
    setTotalPagesCount(Math.ceil(dropdownData.length / rowsPerPage));
  }
  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };
  const updateRowData = () => {
    dropdownData.sort(
      (a, b) =>
        new Date(b.StartDate ? b.StartDate : b.InsertedDateTime) -
        new Date(a.StartDate ? a.StartDate : a.InsertedDateTime)
    )
      return dropdownData?.slice((page - 1) * rowsPerPage, page * rowsPerPage);
  };
  let paginationData = updateRowData();
  useEffect(() => {
    setPage(1);
  }, [dropdownData]);

  let getSearchData = (searchWord) => {
    searchWord = searchWord ? searchWord : undefined;
    let updateData = [];
    setSearchCount(prevSearchCount => prevSearchCount + 1); // initially returns 0
    if(searchCount===0) {
      setSearchUndoData(dropdownData);
    } else {
      dropdownData = searchUndoData;
    }
    if (dropdownData && searchWord && origin !== PREPAID_VALUE) {
      setDropdownData([]);
      updateData = [];
      dropdownData.filter((item, key) => {
        if (origin === ANNOUNCEMENT_VALUE) {
          if (isAnnouncementMatchWithSearch(item, searchWord)) {
            updateData.push(item);
          }
        } else {
          if (isAlertMatchWithSearch(item, searchWord)) {
            updateData.push(item);
          }
        }
      });
      setDropdownData(updateData);
    } else if (dropdownData && searchWord && origin === PREPAID_VALUE) {
      setDropdownData([]);
      let dataCopy = JSON.parse(JSON.stringify(dropdownData));
      dataCopy.forEach((prepaidData) => {
        prepaidData.alertsData = prepaidData.alertsData.filter((item) => {
          return isAlertMatchWithSearch(item, searchWord);
        });
      });
      setDropdownData(dataCopy);
    }
    if (dropdownData && !searchWord) {
      setDropdownData(dropdownData);
    }
  };

  const clearClicked = (clicked) => {
    if(clicked) {
      setDropdownData(searchUndoData);
      setSearchCount(0);
    }
  }
  
  const isAlertMatchWithSearch = (item, searchWord) => {
    let itemDesc,
      itemServiceNotification,
      dateFilter,
      badgeFilter,
      createdDateFilter,
      curlNumber,
      thresholdAmount = false;
    if (item?.Description) {
      itemDesc =
        item?.Description?.toLowerCase().search(searchWord.toLowerCase()) !== -1
          ? true
          : false;
    }
    if (item?.deviceEventTypeDescription) {
      itemServiceNotification =
        item?.deviceEventTypeDescription
          ?.toLowerCase()
          .search(searchWord.toLowerCase()) !== -1
          ? true
          : false;
    }
    dateFilter =
      moment(item?.InsertedDateTime)
        .format(dateTimeFormat)
        .toLowerCase()
        .search(searchWord.toLowerCase()) !== -1
        ? true
        : false;
    if (item?.meterBadgeNumber) {
      badgeFilter = item?.meterBadgeNumber?.includes(searchWord.toLowerCase())
        ? true
        : false;
    }
    if (item?.thresholdAmt) {
      thresholdAmount = item?.thresholdAmount?.includes(searchWord)
        ? true
        : false;
    }
    if (item?.Description) {
      curlNumber = item?.Description?.includes(searchWord) ? true : false;
    }
    createdDateFilter =
      moment(item?.CreatedDateTime)
        .format(dateTimeFormat)
        .toLowerCase()
        .search(searchWord.toLowerCase()) !== -1
        ? true
        : false;
    if (
      itemServiceNotification === true ||
      itemDesc === true ||
      dateFilter === true ||
      badgeFilter === true ||
      createdDateFilter === true ||
      thresholdAmount === true ||
      curlNumber === true
    ) {
      return true;
    } else {
      return false;
    }
  };

  const isAnnouncementMatchWithSearch = (item, searchWord) => {
    let itemDesc, itemServiceNotification, dateFilter,datesearch;
    itemDesc =
      item?.AnnouncementDescription?.toLowerCase().search(
        searchWord.toLowerCase()
      ) !== -1
        ? true
        : false;
    itemServiceNotification =
      item?.AnnouncementTitle?.toLowerCase().search(
        searchWord.toLowerCase()
      ) !== -1
        ? true
        : false;
    dateFilter =
      moment(item?.StartDate)
        .format(dateTimeFormat)
        .toLowerCase()
        .search(searchWord.toLowerCase()) !== -1
        ? true
        : false;
    datesearch = 
    moment(item?.StartDate)
        .format(dateFormat)
        .toLowerCase()
        .search(searchWord.toLowerCase()) !== -1
        ? true
        : false;
    if (
      itemServiceNotification === true ||
      itemDesc === true ||
      dateFilter === true||
      datesearch === true
    ) {
      return true;
    } else {
      return false;
    }
  };
  
  return (
    <Card 
      className={minTablet ? classes.smallInsideCard : classes.insideCard}
      style={{overflowY: browserName === "firefox" ? "auto" : "overlay", scrollbarWidth:browserName === "firefox" ?"thin":"auto"}}
    >
      <E_card_Header title={title} data={dropdownData} setData={setDropdownData} origin={origin} labelReady={labelReady} setAnnLoad={setAnnLoad}
              setMeterLoad={setMeterLoad}
              meterLoad={meterLoad}
              annLoad={annLoad}/>
      <E_Card_Search getSearchData={getSearchData} clearClicked={clearClicked}/>
      <hr className={classes.hrStyle} />
      {isPrepaidSa === "Y" && origin === PREPAID_VALUE ? (
        <E_Prepaid_Alerts 
          item={dropdownData} 
          noContent={noContent} 
          value={value} 
          setValue={setValue} 
          origin={origin}
          autoOpenData={autoOpenData}
          setAutoOpenData={setAutoOpenData}
          labelReady={labelReady}
          noContentContentReady={noContentContentReady}
        />
      ) : (
        <E_Card_Content
          data={paginationData}
          origin={origin}
          displayPadding={true}
          noContent={noContent}
          noContentContentReady={noContentContentReady}
          page={page}
          autoOpenData={autoOpenData}
          setAutoOpenData={setAutoOpenData}
          setAnnLoad={setAnnLoad}
          setMeterLoad={setMeterLoad}
          meterLoad={meterLoad}
          annLoad={annLoad}
        />
      )}
      {totalPagesCount > 1 && (
        <E_PaginatationComponent
          totalPagesCount={totalPagesCount}
          page={page}
          handlePageChange={handlePageChange}
        />
      )}
    </Card>
  );
}
